import { cn } from "utils/helpers";

interface AppVersionProps {
	className?: string;
}

/**
 * The build's version number, shown in the menu footer so a user can quote it
 * when reporting a problem.
 *
 * `REACT_APP_VERSION` is injected from `package.json`'s `version` by the
 * `start`/`dev`/`build` scripts (CRA only exposes `REACT_APP_*`, and its module
 * scope plugin forbids importing `package.json` from outside `src/`). It is
 * absent when a consumer runs `react-scripts` directly — render nothing rather
 * than the string "undefined".
 */
export const AppVersion = ({ className }: AppVersionProps) => {
	const version = process.env.REACT_APP_VERSION;

	if (!version) {
		return null;
	}

	return (
		<span
			className={cn("text-fq-quinary-400", className)}
			data-testid="app-version"
		>
			v{version}
		</span>
	);
};
